import { Job } from '../types';
import { resolvePublicAssetPath, resolvePublicAssetPaths } from './assets';

let availableJobs: Job[] = [];

// 动态加载职业数据
export const loadJobs = async (): Promise<Job[]> => {
  if (availableJobs.length === 0) {
    try {
      const response = await fetch(resolvePublicAssetPath('/data/bard/json/bard.json'));
      const bardData = await response.json();
      availableJobs = [resolvePublicAssetPaths(bardData) as Job];
    } catch (error) {
      console.error('Failed to load job data:', error);
      availableJobs = [];
    }
  }
  return availableJobs;
};

export const getAvailableJobs = (): Job[] => {
  return availableJobs;
};

export const getJobById = (id: string): Job | undefined => {
  return availableJobs.find(job => job.id === id);
};
